'use client';

import { useEffect } from 'react';

import { useHeaderVariant } from '@/shared/contexts/HeaderVariantContext';
import { useBreakpoint } from '@/shared/hooks/useBreakpoint';

export function ProductSubpageLNBConfig() {
  const isDesktop = useBreakpoint('desktop');
  const { setLNBOverlay } = useHeaderVariant();

  useEffect(() => {
    setLNBOverlay(isDesktop ? false : true);
    return () => {
      setLNBOverlay(null);
    };
  }, [setLNBOverlay, isDesktop]);

  return null;
}
 